(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/login/login.tpl.html',
    '<div class="container"><dsa-login title="{{loginTitle}}" loginid="{\'Account\':\'\',\'username\':\'\'}"></dsa-login></div><img style="width:100%;position: absolute;bottom:0px;margin-bottom: 51px" ng-src="assets/images/betosys_big.jpg">');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/login/login.tpl.js